import React from "react";
import { ArrowUpRight, Radio } from "lucide-react";
import { TIKTOK_URL } from "../mock";

export default function LiveTikTok() {
  return (
    <section className="cm-reveal py-8 lg:py-12">
      <div className="mx-auto max-w-[1360px] px-6 lg:px-10">
        <div className="overflow-hidden rounded-[24px] bg-[var(--cm-dark)] px-8 py-12 lg:px-14 lg:py-14">
          <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-[1.4fr_0.8fr]">
            <div>
              <div className="mb-5 flex items-center gap-2">
                <span className="h-2 w-2 animate-pulse rounded-full" style={{ background: "var(--cm-green)" }} />
                <span className="font-mono-cm text-[0.68rem] uppercase tracking-[0.18em] text-[var(--cm-green)]">
                  Live Carmaps su TikTok
                </span>
              </div>
              <h2 className="h-display text-[clamp(1.9rem,3.6vw,2.9rem)] text-white">
                Le auto le mostriamo dal vivo.
              </h2>
              <p className="mt-5 max-w-[520px] text-[0.98rem] leading-relaxed text-white/60">
                Nelle live di Stefano apriamo cofani e portiere, mostriamo lo
                stato d'uso reale e rispondiamo alle domande in diretta. Segui
                @stefano_giardino.carmaps per non perdere le prossime.
              </p>
            </div>
            <div className="lg:justify-self-end">
              <a
                href={TIKTOK_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full bg-white px-6 py-3.5 text-[0.9rem] font-medium text-[var(--cm-ink)] transition-transform duration-200 hover:scale-[1.03]"
              >
                <Radio size={16} />
                Segui le live su TikTok
                <ArrowUpRight size={16} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
